import { render } from "./WelcomePopup.vue?vue&type=template&id=2f9a8691&scoped=true"
import script from "./WelcomePopup.vue?vue&type=script&lang=ts"
export * from "./WelcomePopup.vue?vue&type=script&lang=ts"

import "./WelcomePopup.vue?vue&type=style&index=0&id=2f9a8691&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f9a8691"

export default script